<template>
  <div class="wrapper centered landing" :class="{'sidebar-shown': displaySidebar, 'sidebar-open': sidebarOpen}">
    <sidebar @openSidebar="sidebarOpen = true" @closeSidebar="sidebarOpen = false" />
    <main class="content" :class="{'has-sidebar': displaySidebar}">
      <header class="page landing">
        <h1 class="title is-loading"><span>My SeedMix</span></h1>
        <p class="subtitle">loading...</p>
      </header>
    </main>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
export default {
  data () {
    return {
      displaySidebar: false,
      sidebarOpen: false
    }
  },
  methods: {
    toggleSidebar (open) {
      this.sidebarOpen = open
    }
  },
  components: {
    'sidebar': Sidebar
  },
  mounted () {
    setTimeout(() => {
      this.displaySidebar = true
    }, 1500)
    setTimeout(() => {
      this.$router.push({ name: 'getting-started' })
    }, 4500)
  }
}
</script>

<style lang="scss">

</style>
